<template>
  <div class="f-col menu">
    <div class="f-row ctr menu-header">
      <router-link class="f-row ctr agil-brand" to="/">
        <img src="@/assets/brand-white.png" alt="SITE" />
      </router-link>
    </div>
    <div class="f-col ctr menu-body">
      <SearchBar />
      <MenuList />
    </div>
    <div class="f-col ctr menu-footer">
      <CompanyBox />
    </div>
    <div class="f-row menu-end"></div>
  </div>
</template>

<script>
import SearchBar from "../library/SearchBar";
import MenuList from "./MenuList";
import CompanyBox from "../library/CompanyBox";

export default {
  name: "Menu",
  components: {
    SearchBar,
    MenuList,
    CompanyBox,
  },
};
</script>

<style scoped>
.menu {
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
.menu-header {
  height: 58px;
  max-height: 58px;
  min-height: 58px;
  padding: 0 0.8rem;
  border-bottom: 1px solid #384858;
}

.agil-brand {
  height: 100%;
  margin: 0 5px;
}

.agil-brand > img {
  width: 100px;
}

.menu-body {
  justify-content: flex-start;
  height: 100%;
  margin: 2px 0;
  overflow-y: auto;
}

.menu-footer {
  height: 4.2rem;
  max-height: 4.2rem;
  min-height: 4.2rem;
  margin-top: auto;
  padding: 0 0.4rem;
  border-top: 1px solid #384858;
  border-bottom: 1px solid #384858;
  background-color: #283848;
}

.menu-end {
  width: 100%;
  height: 22px;
  max-height: 22px;
  min-height: 22px;
  background-color: #223242;
}
</style>